
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import DashboardSidebar from "./DashboardSidebar";
import { useAuth } from "@/contexts/AuthContext";

const DashboardLayout = () => {
  return (
    <div className="flex h-screen w-full bg-gray-50 overflow-hidden">
      <DashboardSidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="px-4 py-4">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
